import React, { useEffect } from "react";

import { Button, Card, Col, Form, Image, Input, Row } from "antd";
import { Link, useNavigate } from "react-router-dom";
import CONSTANTS, { appRoot } from "../../../util/constant/CONSTANTS";
import useHttp from "../../../hooks/use-http";
import { getAuthToken, setAuthDetails } from "../../../util/API/authStorage";
import { LockOutlined, MailOutlined } from "@ant-design/icons";
import logo from "../../../asset/logos/icon.svg";
import { ROUTES } from "../../../util/Route";

const LogIn = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const isLogin = getAuthToken() !== undefined && getAuthToken() !== null;
    if (isLogin) {
      navigate(appRoot);
    }
  }, [navigate]);
  const API = useHttp();


  const validateLogin = (value) => {
    const payload = {
      email: value.email,
      password: value.password,
    };
    API.sendRequest(
      CONSTANTS.API.login,
      (res) => {
        setAuthDetails(res?.token);
        localStorage.setItem('role', res?.data?.admin?.role)
        // setLoadings([]);
        window.location.assign(appRoot);
      },
      payload,
      "LogIn Successful"
    );
  };

  return (
    <>

      <div
        className="h-screen flex justify-center  items-center"

      >
        <Row className="">
          <Col span={10} sm={24} xs={24} md={10} lg={10}>
            <div className="mr-10 mt-14 flex content-center justify-center">
              <Image
                src={logo}
                alt="Bash"
                preview={false}
                width={300}
                className="p-5"
              />
            </div>
          </Col>
          <Col span={14} sm={24} xs={24} md={14} lg={14}>
            <Card style={{ background: "#F5F5F5", border: "none" }}>
              <p className="text-3xl mb-4  font-medium	">Login</p>

              <Form
                name="normal_login"
                className="login-form"
                initialValues={{
                  remember: true,
                }}
                onFinish={validateLogin}
              >
                <Form.Item
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Your Email!",
                    },
                  ]}
                >
                  <Input
                    prefix={<MailOutlined className="site-form-item-icon" />}
                    placeholder="Email"
                    type="email"
                  />
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Your Password!",
                    },
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    placeholder="Password"
                  />
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="login-form-button"
                    loading={API?.isLoading}

                  // disabled
                  >
                    Log in
                  </Button>
                </Form.Item>

                <Link to={ROUTES.FORGOT_PASSWORD}>
                  Forgot Password?
                </Link>
              </Form>
              <div>
              </div>
            </Card>
          </Col>
        </Row>
        {/* <Registration /> */}
      </div>
    </>
  );
};
export default LogIn;
